import React from 'react';
import { connect } from 'react-redux';
import { Button } from '@mui/material';
import { withStyles } from 'tss-react/mui';
import { mediaPickerActions } from '../store';
import CircleProgressButton from '../../../../buttons/CircleProgressButton';
import { createActions } from '../../store';
import { createLocalMediaSourceUrls, createMediaSource, createMediaSourceDataForVideo } from '../../helpers';
import { MEDIA_RESOURCE_TYPE, MEDIA_SOURCE_TYPE } from '../../CreatePageConstants';
import AppConstants from '../../../../../App/AppConstants';

const styles = theme => ({
    changeImageButton: {
        marginRight: theme.spacing(2)
    }
});

const CatalogVideoPreviewActions = (props) => {
    const { 
        classes, catalogVideoPreviewProcessing, catalogVideoPreviewData, hideCatalogVideoPreview, 
        setMediaPickersProperty, setPageProperty, updateBackgroundSettings, openPremiumVideosDialog,
        subscriptionType, savingInProgress, showCriticalOperationProgressWarning
    } = props;

    const onCancelClick = () => {
        hideCatalogVideoPreview();
    };

    const onSaveClick = () => {
        if (subscriptionType === AppConstants.FREE_SUBSCRIPTION_TYPE && catalogVideoPreviewData.isPremium) { 
            setMediaPickersProperty('backgroundMediaPickerOpen', false);
            hideCatalogVideoPreview();
            
            openPremiumVideosDialog(catalogVideoPreviewData.urls.exampleUrl, () => {
                setMediaPickersProperty('backgroundMediaPickerOpen', true);
            }, 'catalog videos');
        } else {
            // Don't apply the catalog video if the save operation is in progress.
            if (savingInProgress) {
                showCriticalOperationProgressWarning();
                return;
            }

            const mediaData = createMediaSourceDataForVideo(
                catalogVideoPreviewData.urls.p1080Url, 
                catalogVideoPreviewData.urls.p720Url, 
                catalogVideoPreviewData.urls.p540Url, 
                catalogVideoPreviewData.urls.p360Url
            );

            const mediaSource = createMediaSource(mediaData, MEDIA_SOURCE_TYPE.VIMEO, catalogVideoPreviewData.catalogVideoId, MEDIA_RESOURCE_TYPE.VIDEO);
    
            setPageProperty('backgroundVideosLoading', true);
            createLocalMediaSourceUrls(mediaSource, (localMediaSource) => {
                updateBackgroundSettings({ mediaSource: localMediaSource });
                setPageProperty('backgroundVideosLoading', false);
            });
    
            setMediaPickersProperty('backgroundMediaPickerOpen', false);
            hideCatalogVideoPreview();
        }
    };

    return (
        <>
            <Button
                className={classes.changeImageButton} 
                onClick={onCancelClick}
            >
                Cancel
            </Button>
            <CircleProgressButton
                onClick={onSaveClick}
                loading={catalogVideoPreviewProcessing}
                variant='outlined'
                color='primary'
            >
                Save
            </CircleProgressButton>
        </>
    );
};

const mapStateToProps = (state) => {
    const { 
        catalogVideoPreviewProcessing, 
        catalogVideoPreviewData 
    } = state.mediaPicker;

    const { subscriptionType } = state.app.accountDetails;
    const { savingInProgress } = state.create.videoSavingState;

    return { 
        catalogVideoPreviewProcessing,
        catalogVideoPreviewData,
        subscriptionType,
        savingInProgress
    };
}

const mapDispatchToProps = (dispatch) => {
    const setMediaPickersProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const setPageProperty = (key, value) => dispatch(createActions.setProperty(key, value));
    const updateBackgroundSettings = (properties) => dispatch(createActions.updateBackgroundSettings(properties));
    const hideCatalogVideoPreview = () => dispatch(mediaPickerActions.hideCatalogVideoPreview());
    const openPremiumVideosDialog = (videoUrl, onGoBack, location) => dispatch(mediaPickerActions.openPremiumVideosDialog(videoUrl, onGoBack, location));
    const showCriticalOperationProgressWarning = () => dispatch(createActions.showCriticalOperationProgressWarning());

    return { 
        setMediaPickersProperty,
        setPageProperty,
        updateBackgroundSettings,
        hideCatalogVideoPreview,
        openPremiumVideosDialog,
        showCriticalOperationProgressWarning
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(CatalogVideoPreviewActions, styles));